/* eslint-disable react/prop-types */
import React from 'react';
import { EnhancedDataTableContext } from './EnhancedDataTableContext';
import EnhancedTable from './EnhancedTable';

const EnhancedDataTable = React.memo((props) => {
  const { tableData } = props;

  if (tableData && !tableData.defaultColumn) {
    tableData.defaultColumn = { hasDefaultColumn: false };
  }

  const contextValue = {
    ...props.tableData,
    defaultTableSettings: props.defaultTableSettings,
    tableData: props.tableData,
    onPageChange: props.onPageChange,
    onRowCheckChange: props.onRowCheckChange,
    onHeaderRowCheckChange: props.onHeaderRowCheckChange,
    onTableSettingsChange: props.onTableSettingsChange,
    onSortClick: props.onSortClick,
    onFilter: props.onFilter,
    onHeaderPosChange: props.onHeaderPosChange,
    onFilterReset: props.onFilterReset,
    onFilterIconClicked: props.onFilterIconClicked,
    fetchTableData: props.fetchTableData,
    setTableData: props.setTableData,
    onItemActionClick: props.onItemActionClick,
    resetTableSelection: props.resetTableSelection,
    loginData: props.loginData,
    apiHostService: props.apiHostService,
    disableCheckbox: props.disableCheckbox,
    onExportClick: props.onExportClick,
    paginationType: props.paginationType,
    dispatch: props.dispatch,
    showToolBar: props.showToolBar,
  };

  return (
    <EnhancedDataTableContext.Provider value={contextValue}>

      <EnhancedTable> </EnhancedTable>

    </EnhancedDataTableContext.Provider>
  );
});

EnhancedDataTable.displayName = 'EnhancedDataTable';

export default EnhancedDataTable;
